import {
  SELECT_LOCALE,
  SET_UPPERCASE_LABELS
} from 'shared/actions/types';

export const selectLocale = locale => dispatch => {
  dispatch({
    type: SELECT_LOCALE,
    payload: locale
  });
}

export const setUppercaseLabels = bool => dispatch => {
  dispatch({
    type: SET_UPPERCASE_LABELS,
    payload: bool
  });

  return Promise.resolve();
}
